import axios from "axios";
import { base } from "../base";

// "Talk to Stan" — the website support chatbot (backend: /api/chatbot).

export const initiateChat = async (data) => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/chatbot/chat`,
    data: data,
  });
  return response;
};

export const handoverToAdmin = async (data) => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/chatbot/handover`,
    data: data,
  });
  return response;
};

export const getConversation = async (sessionId) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/chatbot/conversation/${encodeURIComponent(sessionId)}`,
  });
  return response;
};
